export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';

export const GET_NOTIFICATIONS_NUMBER = 'GET_NOTIFICATIONS_NUMBER';
export const GET_NOTIFICATIONS_NUMBER_SUCCESS = 'GET_NOTIFICATIONS_NUMBER_SUCCESS';
export const GET_NOTIFICATIONS_NUMBER_FAILURE = 'GET_NOTIFICATIONS_NUMBER_FAILURE';